<template>
  <div style="margin-bottom: -16px">
    <template v-if="this.isRegular">
      <div class="verticallyCenter mb16" v-if="isShowRow">
        <span class="fs14 mr16">行数</span>
        <div class="row-set">
          <div class="verticallyCenter el-input">
            <single-input
              class="mr8"
              style="width: 104px; flex: 1"
              :value.sync="rowsLen"
              :noInputSuffixs="true"
              :min="minSize"
              :max="maxSize"
              :noInputHandle="true"
              @customBlur="onRowBlur"
              @keyup="onRowKeyUp"
              @changeValue="onRowBlur"
            />
            <div class="btn-wrapper">
              <span
                :class="rowsLen === minSize ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
                @click="changeRow(0)"
              ></span>
              <span
                :class="rowsLen === maxSize ? 'disabled num-btn icon-portal-plus' : 'num-btn icon-portal-plus'"
                @click="changeRow(1)"
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div class="verticallyCenter"  v-if="isShowCol">
        <span class="fs14 mr16">列数</span>
        <div class="row-set">
          <div class="verticallyCenter el-input">
            <single-input
              class="mr8"
              style="width: 104px; flex: 1"
              :value.sync="colsLen"
              :noInputSuffixs="true"
              :min="minSize"
              :max="maxSize"
              :noInputHandle="true"
              @customBlur="onColBlur"
              @keyup="onColKeyUp"
              @changeValue="onColBlur"
            />
            <div class="btn-wrapper">
              <span
                :class="colsLen === minSize ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
                @click="changeCol(0)"
              ></span>
              <span
                :class="colsLen === maxSize ? 'disabled num-btn icon-portal-plus' : 'num-btn icon-portal-plus'"
                @click="changeCol(1)"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="setting-item clearFloat verticallyCenter">
        <div class="verticallyCenter mr16">
          <span class="fs14 mr8 keep-all">行数</span>
          <single-input style="width: 68px" :value.sync="rowsLen" inputSuffixs="行" />
        </div>
        <div class="verticallyCenter">
          <span class="fs14 mr8 keep-all">列数</span>
          <single-input style="width: 68px" :value.sync="colsLen" inputSuffixs="列" />
        </div>
      </div>
      <el-button
        style="width: 100%; font-size: 14px"
        class="mt16"
        size="small"
        type="primary"
        :disabled="!enableEdit"
        @click="addTable"
        >{{ this.isRegular ? "生成布局" : "重置布局" }}</el-button
      >
    </template>
  </div>
</template>

<script>
import {
  handleFindLayoutComponentOptionsCols,
  checkIrregularLayout,
  getAllColsUidInLayoutComponent,
  handleFindLayoutComponentAllUid,
  recordOldSize
} from "../../../utils"
import { deepCloneAndFreeze } from "utils/revork"
import { CATEGORY_MODE } from "@/consts"
export default {
  data() {
    return {
      this1: this,
      colsLen: 1,
      rowsLen: 1,
      oldColsLen: 1,
      oldRowsLen: 1,
      // 非正常布局
      isRegular: true,
      pageSize: 10,
      minSize: 1,
      maxSize: 50
    }
  },
  props: {
    options: { type: Object },
    isLayout: { type: Boolean }
  },
  watch: {
    ids: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.rect_id === undefined || !this.getOptions.rows) {
          return
        }
        let topOptions = null
        // 选中自由布局
        const useActiveIndex = this.getOptions?.categoryMode === CATEGORY_MODE.SAME ? 0 : this.getOptions.activeIndex
        if (this.isLayout) {
          topOptions = this.getOptions.rows[useActiveIndex]
          recordOldSize.call(this, this.getOptions)
        } else {
          // 选中单元格
          const pOptions = [this.getOptions.rows[useActiveIndex]]
          topOptions = handleFindLayoutComponentOptionsCols(pOptions, this.ids.uid)
        }
        const regularResult = checkIrregularLayout(topOptions)
        const { regular, rowLens, colLens } = regularResult
        this.isRegular = regular
        this.rowsLen = this.oldRowsLen = rowLens
        this.colsLen = this.oldColsLen = colLens
      }
    },
    "options.encId": {
      deep: true,
      handler() {
        this.computeLayout()
      }
    },
    "options.turnOnScroll": {
      handler() {
        // 修改自动滚动后，需要延时更新行列数
        setTimeout(() => {
          this.computeLayout()
        }, 1000)
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    getOptions: function () {
      if (this.getRectAttribute.call(this, this.ids).shape === "cxAutoLayout") {
        return this.getAttrById(this.$store.state[this.request_prefix], this.ids, "elementInAutoLayout")
      }
      return this.getRectAttribute.call(this, this.ids).options
    },
    isShowCol(){
      // 手风琴多行模式不允许添加列
      if(!this.options){
        return true
      } else if(this.options.componentTypeName !== "cxSystemAccordion"){
        return true
      } else  if(this.options.accordionType === "vertical"){
        return false
      } else{
        return true
      }
    },
    isShowRow(){
      // 手风琴多列模式不允许添加行
      if(!this.options){
         return true
      } else if(this.options.componentTypeName !== "cxSystemAccordion"){
        return true
      } else  if(this.options.accordionType !== "vertical"){
        return false
      } else{
        return true
      }
    },
    // 只有行或者列和之前不一样，才可以编辑
    enableEdit() {
      return (
        (this.rowsLen !== this.oldRowsLen || this.colsLen !== this.oldColsLen) && this.rowsLen > 0 && this.colsLen > 0
      )
    }
  },
  methods: {
    // 重新计算布局
    computeLayout() {
      if (!this.options.rows) {
        return
      }
      const useActiveIndex = this.options.categoryMode === CATEGORY_MODE.SAME ? 0 : this.options.activeIndex
      const topOptions = this.options.rows[useActiveIndex]
      const regularResult = checkIrregularLayout(topOptions)
      const { regular, rowLens, colLens } = regularResult
      this.isRegular = regular
      this.rowsLen = this.oldRowsLen = rowLens
      this.colsLen = this.oldColsLen = colLens
    },
    // 生成新的布局
    addTable() {
      //处理背景色
      this.handleBGC()
      if (!this.isRegular) {
        this.$confirm("确定重置布局吗？", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          showClose: false,
          dangerouslyUseHTMLString: "<p>确定重置布局吗？</p>",
          iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
          cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
          confirmButtonClass: `${this.request_prefix}_confirm_button`,
          customClass: `${this.request_prefix}_confirm custom_warning_dialog`
        })
          .then(() => {
            this.before = this.getQuickShot()
            this.resetLayout()
            this.checkUidContainer()
            // 重置后默认为1行1列
            this.oldRowsLen = 1
            this.oldColsLen = 1
            this.editNewRowAndCol(true)
            this.oldRowsLen = this.rowsLen
            this.oldColsLen = this.colsLen
            this.computeLayout()
          })
          .catch(() => {})
        return
      } else {
        this.editNewRowAndCol()
      }
    },
    onRowKeyUp(e) {
      if (e.keyCode === 13) {
        e.target.blur()
        this.onRowBlur()
      }
    },
    onColKeyUp(e) {
      if (e.keyCode === 13) {
        e.target.blur()
        this.onColBlur()
      }
    },
    onRowBlur() {
      if (this.rowsLen !== this.oldRowsLen && this.rowsLen >= this.minSize && this.rowsLen <= this.maxSize) {
        this.editNewRowAndCol()
      } else {
        this.rowsLen = this.oldRowsLen
      }
    },
    onColBlur() {
      if (this.colsLen !== this.oldColsLen && this.colsLen >= this.minSize && this.colsLen <= this.maxSize) {
        this.editNewRowAndCol()
      } else {
        this.colsLen = this.oldColsLen
      }
    },
    // 修改列的值
    changeCol(flag) {
      if (flag === 1) {
        if (this.colsLen < this.maxSize) {
          this.colsLen++
          this.editNewRowAndCol()
        }
      } else {
        if (this.colsLen > this.minSize) {
          this.colsLen--
          this.editNewRowAndCol()
        }
      }
    },
    // 修改行的值
    changeRow(flag) {
      if (flag === 1) {
        if (this.rowsLen < this.maxSize) {
          this.rowsLen++
          this.editNewRowAndCol()
        }
      } else {
        if (this.rowsLen > this.minSize) {
          this.rowsLen--
          this.editNewRowAndCol()
        }
      }
    },
    // 编辑新的行列
    editNewRowAndCol(resetFlag) {
      if (!resetFlag) {
        this.before = this.getQuickShot()
      }
      // 判断行、列是增加还是删减，然后操作
      const addColLen = this.colsLen - this.oldColsLen
      const addRowLen = this.rowsLen - this.oldRowsLen
      // 如果没有布局类型，先修改的列，视为列布局，否则为行布局
      let layoutType = "row"
      if (addRowLen === 0) {
        layoutType = "col"
      }
      if (addColLen !== 0) {
        if (addColLen > 0) {
          this.$store.dispatch(this.request_prefix + "/updateColLenInLayout", {
            ...this.ids,
            type: "add",
            // 注意，新增列时，行数要为之前的值。因为这里需要先生成列，后生成行
            rowsLen: +this.oldRowsLen,
            colsLen: +this.colsLen,
            addLen: Math.abs(addColLen),
            layoutType,
            editType: this.isLayout ? "layout" : "cell"
          })
        } else {
          this.$store.dispatch(this.request_prefix + "/updateColLenInLayout", {
            ...this.ids,
            type: "sub",
            rowsLen: +this.rowsLen,
            colsLen: +this.colsLen,
            subLen: Math.abs(addColLen),
            moveLastLeaf: +this.rowsLen === 1 && +this.colsLen === 1 && addRowLen === 0,
            editType: this.isLayout ? "layout" : "cell"
          })
        }
      }
      this.checkUidContainer()
      if (addRowLen !== 0) {
        if (addRowLen > 0) {
          this.$store.dispatch(this.request_prefix + "/updateRowLenInLayout", {
            ...this.ids,
            type: "add",
            rowsLen: +this.rowsLen,
            colsLen: +this.colsLen,
            addLen: Math.abs(addRowLen),
            layoutType,
            editType: this.isLayout ? "layout" : "cell"
          })
        } else {
          this.$store.dispatch(this.request_prefix + "/updateRowLenInLayout", {
            ...this.ids,
            type: "sub",
            rowsLen: +this.rowsLen,
            colsLen: +this.colsLen,
            subLen: Math.abs(addRowLen),
            moveLastLeaf: +this.rowsLen === 1 && +this.colsLen === 1,
            editType: this.isLayout ? "layout" : "cell"
          })
        }
      }
      this.checkUidContainer()
      let { renderOrder, activeIndex } = this.getOptions
      // 旧数据格式不同的清除重做
      if (Array.isArray(renderOrder)) {
        renderOrder = {}
      }
      const newRenderOrder = Object.assign(renderOrder || {}, { [activeIndex]: [] })
      this.$changeOptionsEV(
        newRenderOrder,
        "renderOrder",
        null,
        false,
        {
          ...this.ids
        },
        true
      )
      this.copyLayoutStyle()
      if (this.options) {
        const useActiveIndex = this.options.categoryMode === CATEGORY_MODE.SAME ? 0 : this.options.activeIndex
        let colsIdFromActiveRect = getAllColsUidInLayoutComponent([this.options.rows[useActiveIndex]])
        this.pageSize = colsIdFromActiveRect && colsIdFromActiveRect.length
        if (this.options.turnOnScroll) {
          this.$changeOptionsEV(false, "turnOnScroll", false, null, this.ids, true)
        }
      }
      this.oldRowsLen = this.rowsLen
      this.oldColsLen = this.colsLen
      this.changeOldSize()
    },
    // 检查修改行列时，是否有新的包装布局
    checkUidContainer() {
      const activeUid = sessionStorage.getItem("willActiveUid")
      if (activeUid) {
        const activeID = {
          ...this.ids,
          uid: activeUid
        }
        console.log("activeID",activeID)
        this.$store.commit("states/changeActiveID", activeID)
        sessionStorage.removeItem("willActiveUid")
      }
    },
    // 重置布局
    resetLayout() {
      const param = {
        ...this.ids,
        uid: this.ids.uid,
        editType: this.isLayout ? "layout" : "cell"
      }
      this.$store.dispatch(this.request_prefix + "/resetLayoutBlock", param)
    },
    handleBGC() {
      let tempNode = document.getElementById(this.ids.uid)
      if (tempNode) {
        tempNode.childNodes[0].style.backgroundColor = null
      } else {
        const _node = document.getElementById(`componentBox_after${this.ids.uid}`)
        _node ? (_node.style.backgroundColor = null) : ""
      }
    },
    // 复制单元格样式
    copyLayoutStyle() {
      const addUids = JSON.parse(sessionStorage.getItem("addUids") || "[]")
      if (addUids.length) {
        if (!this.options) return
        const useActiveIndex = this.options?.categoryMode === CATEGORY_MODE.SAME ? 0 : this.options.activeIndex
        const colUids = []
        let topRows = null
        if (this.isLayout) {
          topRows = this.options.rows[useActiveIndex].cols[0].rows
        } else {
          const _useActiveIndex = this.getOptions?.categoryMode === CATEGORY_MODE.SAME ? 0 : this.getOptions.activeIndex
          const pOptions = [this.getOptions.rows[_useActiveIndex]]
          topRows = handleFindLayoutComponentOptionsCols(pOptions, this.ids.uid).rows
        }
        handleFindLayoutComponentAllUid(topRows, colUids)
        // 获取基准值，用于复制样式的参照物，遍历叶子节点，第一个就是基准值
        const reference = colUids[0]
        for (let i = 0; i < addUids.length; i++) {
          const pOptions = [this.getOptions.rows[useActiveIndex]]
          const baseId = { container_id: this.ids.container_id, rect_id: this.ids.rect_id,  path: this.ids.path,
            elementInAutoLayoutId: this.ids.elementInAutoLayoutId}
          console.log("aaaa",handleFindLayoutComponentOptionsCols(pOptions, reference))
          const result = {
            ...this.ids,
            baseUid: reference,
            content: JSON.parse(JSON.stringify(handleFindLayoutComponentOptionsCols(pOptions, reference))),
            uid: addUids[i]
          }
          this.$event.mergeEvent(
            {
              from: { ...baseId, uid: reference },
              to: { ...baseId, uid: addUids[i] }
            },
            "col"
          )
          this.$store.dispatch(this.request_prefix + "/changeLayoutComponentBoxOption", result)
        }
        // 模拟点击
        if (this.options?.myFetchParam) {
          let getDataBtn = document.getElementsByClassName("toolbar")[0].getElementsByClassName("getDataBtn")
          if (getDataBtn.length > 0) {
            getDataBtn[0].click()
          }
        }
        // 等待添加的单元格dom挂载，然后执行尺寸匹配
        const watchFirstUidBtn = () => {
          requestAnimationFrame(() => {
            const addFirstBtn = document.getElementById(addUids[0])
            if (!addFirstBtn) {
              watchFirstUidBtn()
            } else {
              // 会遍历所有的，调整元素在单元格内
              const data = {
                container_id: this.ids.container_id,
                rect_id: this.ids.rect_id,
                path: this.ids.path,
                elementInAutoLayoutId: this.ids.elementInAutoLayoutId
              }
              this.$store.dispatch(this.request_prefix + "/changeLayoutCellBoxOptionSize", data)
              this.addHistory()
              sessionStorage.removeItem("addUids")
            }
          })
        }
        watchFirstUidBtn()
      } else {
        this.addHistory()
        // 模拟点击
        if (this.options?.myFetchParam) {
          let getDataBtn = document.getElementsByClassName("toolbar")[0].getElementsByClassName("getDataBtn")
          if (getDataBtn.length > 0) {
            getDataBtn[0].click()
          }
        }
      }
    },
    // 获取当前快照
    getQuickShot() {
      const { container_id, rect_id } = this.ids
      const page = this.$store.state[this.request_prefix].page
      const rect = page.children[0].children.find(rect => rect.rect_id === rect_id)
      return deepCloneAndFreeze(rect)
    },
    // 修改自由布局原始尺寸
    changeOldSize() {
      // 选中自由布局
      if (!this.isLayout) {
        return
      }
      const { oldRowsLength = {}, oldColsLength = {}, tabsList = [], categoryMode, activeIndex } = this.getOptions
      let index = 0
      if (tabsList.length > 0 && tabsList[0].name === "全部" && !tabsList[0].id) {
        index = tabsList.length > 1 ? 1 : 0
      }
      const useActiveIndex = categoryMode === CATEGORY_MODE.SAME ? 0 : activeIndex
      const tabId = tabsList.length === 0 ? useActiveIndex : (tabsList[index].id || 0)
      const rowsLength = { ...oldRowsLength }
      rowsLength[tabId] = this.rowsLen
      const colsLength = { ...oldColsLength }
      colsLength[tabId] = this.colsLen
      this.$changeOptionsEV(rowsLength, "oldRowsLength", false, null, { ...this.ids }, true)
      this.$changeOptionsEV(colsLength, "oldColsLength", false, null, { ...this.ids }, true)
    },
    // 记录状态
    addHistory() {
      const newData = this.getQuickShot()
      this.$addHistory({
        type: "update",
        stateType: "updateRect",
        payload: {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          path: this.ids.path,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId
        },
        before: this.before,
        data: newData
      })
      this.before = null
    }
  }
}
</script>

<style lang="scss" scoped>
.add_box {
  width: 100%;
  padding: 5px 5%;
  margin-bottom: 5px;
  border: 1px solid skyblue;
  div {
    margin-top: 5px;
  }
}
.slider {
  width: 260px;
  float: left;
}
.slider-input-container {
  padding-left: 0;
}
.keep-all {
  word-break: keep-all;
}
.row-set {
  flex: 1;
  input {
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-right: 16px;
  }
  .btn-wrapper {
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 6px 0;
    font-size: 0;
    flex: 1;
    .num-btn {
      display: inline-block;
      width: 50%;
      text-align: center;
      line-height: 20px;
      font-size: 13px;
      cursor: pointer;
      &:not(:last-child) {
        border-right: 1px solid var(--sliderBackGround);
      }
      &:not(.disabled):hover {
        color: var(--themeColor);
      }
      &.disabled {
        color: var(--borderColorSeven);
        cursor: not-allowed;
      }
    }
  }
}
</style>
